import React, { useState } from 'react';
import { noop } from 'lodash';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import PropTypes from 'prop-types';

export const Badge = ({
  name, size, image, badgeType, additionalContent, onShowTooltip
}) => {
  const style = size ? { width: size, height: size } : null;
  const [interacted, setInteracted] = useState(false);

  const handleToolTip = () => {
    // limits the number of times analytics are triggered
    if (!interacted) {
      setInteracted(true);
      onShowTooltip();
    }
  };

  return (
    <Tooltip
      channel="desktop"
      className="ptp-profile-badge__text"
      content={(
        <>
          <b>{name}</b>
          <p>{additionalContent}</p>
        </>
      )}
      interactive
      onShow={handleToolTip}
    >
      <img
        data-testid={`badge-${badgeType}`}
        className="ptp-profile-badge__img"
        alt={`${name} badge`}
        style={style}
        src={image}
      />
    </Tooltip>
  );
};

Badge.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  image: PropTypes.string.isRequired,
  badgeType: PropTypes.string.isRequired,
  additionalContent: PropTypes.node,
  onShowTooltip: PropTypes.func
};

Badge.defaultProps = {
  size: '',
  additionalContent: '',
  onShowTooltip: noop
};
